<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.employeeDetails | titlecase }}
  </h6>
</div>
<mat-dialog-content>
  <p class="body1 semibold">{{data.ee.name}}</p>
  <p class="caption">{{data.ee.email}}</p>
  @if (data.showEmployer) {
    <p class="caption">{{data.ee.company}}</p>
  }
  <h2 class="overline grey1 semibold section-title">{{ data.sysText.roles }}</h2>
  <mat-divider class="section-header-underline"></mat-divider>
  @for (role of data.ee.roles; track role) {
    <div>
      <p class="body2 semibold">{{role.name}}</p>
      <p class="caption description">{{role.notes}}</p>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-stroked-button
    class="button"
    mat-dialog-close
    color="accent"
    >
    {{ data.sysText.close }}
  </button>
</mat-dialog-actions>
